class APIConnector {
  constructor(baseSettings = {}) {
    this.baseSettings = baseSettings;
  }

  onResultClick() {
    // optional. Called when a result has been clicked
  }
  onAutocompleteResultClick() {
    // optional. Called when an autocomplete result has been clicked
  }

  async onSearch(requestState, queryConfig) {

    const where = process.env.NEXT_PUBLIC_SEARCH_API || '/api/search'
    const response = await fetch(where, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CR-BaseSettings": this.baseSettings,
      },
      credentials: 'include', 
      body: JSON.stringify({
        requestState,
        queryConfig
      })
    });
    return response.json();
  }

  // TODO - revisit this
  async onAutocomplete(requestState, queryConfig) {
    const response = await fetch("api/autocomplete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        requestState,
        queryConfig
      })
    });
    return response.json();
  }
}

export default APIConnector;

